/**
 * List of allowed tracking parameters that can be passed through redirects and links.
 * These parameters are commonly used for marketing attribution and analytics.
 */
export const allowedTrackingParams: readonly string[] = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "sType",
  "source",
  "jsuid",
] as const;

/**
 * Adds tracking parameters from source URLSearchParams to target URLSearchParams.
 * Only adds parameters that are in the allowedTrackingParams list and don't already exist in target.
 *
 * @param targetParams - The target URLSearchParams to add parameters to
 * @param sourceParams - The source URLSearchParams to copy parameters from
 */
export function addTrackingParams(
  targetParams: URLSearchParams,
  sourceParams: URLSearchParams
): void {
  sourceParams.forEach((value, param) => {
    if (allowedTrackingParams.includes(param) && !targetParams.has(param)) {
      targetParams.append(param, value);
    }
  });
}
